import React, { useRef } from 'react';
import USBOptionButtonGroup from '@usb-inner-src/react-forms-group-option-button';
import '@usb-inner-src/react-forms-group-option-button/dist/library/styles/scss/index.scss';

function QuestionOptionButton({
    id,
    metadata,
    answers,
    updateCallback = () => {},
    dynamicErrorCount,
    errorMessages,
    inputValue,
}) {
    // let isError = false;
    // if (dynamicErrorCount < 0) {
    //     isError = false;
    // } else if (dynamicErrorCount && !inputValue) {
    //     isError = true;
    // }
    const optionbtnRef = useRef();
    const convertedAnswers = answers.map((thisAnswer) => ({
        label: thisAnswer.label,
        value: thisAnswer.id,
    }));
    return (
        <USBOptionButtonGroup
            ref={optionbtnRef}
            inputName={id}
            legendText={metadata?.question}
            options={convertedAnswers}
            statusUpdateCallback={updateCallback}
            errorMessages={{
                default:
                    errorMessages.validationMsg ||
                    'Please choose an option.',
            }}
            dynamicErrorCount={dynamicErrorCount}
            // isError={isError}
            dynamicValue={inputValue}
            variant="inline"
            // errorText={errorMessages.validationMsg}
        />
    );
}

export default QuestionOptionButton;
